import { motion } from "framer-motion";
import { NOOR } from "@/constants/testIds/noor";
import { fadeUp, fadeUpSmall, trans } from "./motion";

const COPY = [
  { id: "heritage-name", text: "The name Noor is drawn from the old word for light — a tribute to the candle-lit thrones of the Mughal era, when crystal vessels held the rarest elixirs of the world. Within that lineage, we plant our roots." },
  { id: "heritage-craft", text: "Our blanco is harvested from the highlands of Jalisco — Agave Azul aged eight summers under volcanic skies, pressed by hand, and distilled twice in copper. What pours into the crystal is a quiet kind of fire." },
];

const STATS = [
  { num: "100%", label: "Agave Azul" },
  { num: "08", label: "Years aged in field" },
  { num: "02", label: "Copper distillations" },
  { num: "06", label: "Bottles per batch" },
];

function Stat({ num, label }) {
  return (
    <div>
      <p className="stat-num">{num}</p>
      <div className="hairline my-3" />
      <p className="overline" style={{ fontSize: "0.62rem" }}>{label}</p>
    </div>
  );
}

export default function Heritage() {
  return (
    <section data-testid={NOOR.heritageSection} id="heritage" className="relative py-32 md:py-44">
      <span id="manifesto-anchor" className="absolute -top-24" aria-hidden />
      <div className="max-w-[1480px] mx-auto px-6 md:px-10 grid grid-cols-12 gap-y-10 md:gap-10">
        <div className="col-span-12 lg:col-span-3">
          <p className="overline mb-4">I · Heritage</p>
          <span className="ornament" />
        </div>
        <div className="col-span-12 lg:col-span-7 lg:col-start-5">
          <motion.h2
            {...fadeUp}
            transition={trans(1)}
            className="font-display text-4xl md:text-5xl lg:text-6xl leading-[1.05]"
            style={{ color: "var(--text-primary)" }}
          >
            Born of two kingdoms — <br />
            the <em className="italic" style={{ color: "var(--accent-rose)" }}>Mughal courts</em><br />
            and the <em className="italic" style={{ color: "var(--accent-rose)" }}>Mexican fields</em>.
          </motion.h2>

          <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16">
            {COPY.map((item, i) => (
              <motion.p
                key={item.id}
                {...fadeUpSmall}
                transition={trans(0.8, 0.2 + i * 0.15)}
                className="text-base md:text-lg font-light leading-relaxed"
                style={{ color: "var(--text-secondary)" }}
              >
                {item.text}
              </motion.p>
            ))}
          </div>

          <div className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-8">
            {STATS.map((s) => <Stat key={s.label} {...s} />)}
          </div>
        </div>
      </div>
    </section>
  );
}
